// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "meta_pending_connection".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "meta_pending_connection" table (1:1 with a DB row, on the wire). */
export const metaPendingConnectionAtomSchema = z.object({
    id: z.string(),
    encryptedCredentials: z.string(),
    tokenExpiresAt: z.string().datetime().nullable(),
    metaUserName: z.string().nullable(),
    availablePages: z.unknown(),
    grantedScopes: z.unknown(),
    availableAdAccounts: z.unknown(),
    claimedByOrganizationId: z.string().nullable(),
    claimedAt: z.string().datetime().nullable(),
    isClaimed: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=metaPendingConnection.js.map